import { render, staticRenderFns } from "./ConciergeUpsertForm.vue?vue&type=template&id=3b61e40e"
import script from "./ConciergeUpsertForm.vue?vue&type=script&lang=js"
export * from "./ConciergeUpsertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports